export default "__VITE_ASSET__8_iU48f___"